import request from '@/utils/request'

export const productApi = {
  // 创建商品
  create(data) {
    return request({
      url: '/inventory-management-api/product/create',
      method: 'POST',
      data
    })
  },

  // 更新商品
  update(data) {
    return request({
      url: '/inventory-management-api/product/update',
      method: 'POST',
      data
    })
  },

  // 删除商品
  delete(data) {
    return request({
      url: '/inventory-management-api/product/delete',
      method: 'POST',
      data
    })
  },

  // 商品列表
  list(data) {
    return request({
      url: '/inventory-management-api/product/list',
      method: 'POST',
      data
    })
  },

  // 商品详情
  detail(id) {
    return request({
      url: '/inventory-management-api/product/detail',
      method: 'POST',
      data: {
        "id": id
      }
    })
  },

  // 查询商品简单信息（用于下拉选择）
  querySimpleInfo(data) {
    return request({
      url: '/inventory-management-api/product/queryProductSimpleInfo',
      method: 'POST',
      data
    })
  },

  // 查询带分类层次的商品信息
  queryProductSimpleInfoWithCategory(data) {
    return request({
      url: '/inventory-management-api/product/queryProductSimpleInfoWithCategory',
      method: 'POST',
      data
    })
  },

  // 获取商品分类树
  getCategoryTree() {
    return request({
      url: '/inventory-management-api/common/category/tree',
      method: 'POST',
      data: {
        type: 'product'
      }
    })
  },

  // 获取商品属性
  getAttributes(type) {
    return request({
      url: '/inventory-management-api/common/attribute/list',
      method: 'POST',
      data: { type }
    })
  },

  // 批量更新商品属性
  batchUpdateAttributes(data) {
    return request({
      url: '/inventory-management-api/common/attribute/batchUpdate',
      method: 'POST',
      data
    })
  }
}
